import { GlRepository } from "../repositories/GlRepository";
import { GlOperationResult } from "../entities/GlEntity";

/**
 * Create GL Use Case
 * Creates a new GL in Zoho and gl_map, or submits for review
 */
export class CreateGlUseCase {
  constructor(private repository: GlRepository) {}

  async execute(payload: {
    account_name: string;
    account_type: string;
    parent_account_id?: string | null;
    invoice?: boolean;
    bill?: boolean;
    node_kind?: "ledger" | "group";
    request_comments?: string;
  }): Promise<GlOperationResult> {
    return this.repository.createGl(payload);
  }
}
